import { render, staticRenderFns } from "./RzpPayment.vue?vue&type=template&id=5a962474&scoped=true&"
import script from "./RzpPayment.vue?vue&type=script&lang=js&"
export * from "./RzpPayment.vue?vue&type=script&lang=js&"
import style0 from "./RzpPayment.vue?vue&type=style&index=0&id=5a962474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a962474",
  null
  
)

export default component.exports